import { LevelModel } from '@/types';

export interface FilterState {
    level: LevelModel | null;
    dateRange: Array<Date>;
}
